import axios from 'axios';
import * as Config from '../../config';

const state = {
    categories: {},
    category: {},
}

const actions = {

    load_Categories({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'category/list/all')
                .then(
                    response => {
                        //commit('LOAD_CATEGORIES',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    }, 
    load_Categories_last({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'category/last_period')
                .then(
                    response => {
                        //commit('LOAD_CATEGORIES',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_Categories_period({ commit, dispatch }, period) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'category/period/'+period)
                .then(
                    response => {
                        //commit('LOAD_CATEGORIES',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_CategoriesActivated({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'category/activated/list/all')
                .then(
                    response => {
                        //commit('LOAD_CATEGORIES',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_Category({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'category/consult/' + form.id)
                .then(
                    response => {
                        //commit('LOAD_CATEGORY', data);
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    new_Category({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'category/store', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeActive_Category({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'category/change/active/' + form.id + '/' + form.active)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeStatus_Category({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'category/change/status/' + form.id + '/' + form.status)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_Category({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'category/update/' + form.id, form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    delete_Category({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'category/change/active/' + form.id + '/' + form.active)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    category_create_period({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'category/create-period')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    category_update_period({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'category/update-period', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    category_delete_period({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'category/delete-period', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    category_update_by_csv({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'category/update-by-csv', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
}

const mutations = {

}

export default {
    state,
    actions,
    mutations
}